import { CardContent, Grid } from "@material-ui/core";
import React from "react";
import { Field } from "../../helpers";

export const FakeForm = (props) => {
  const { config } = props;
  return (
    <>
      <CardContent>
        <Grid container spacing={2}>
          {
            config.fields.map((x, index)=>
              <Field key={index} fake={true} field={x}/>
            )
          }
        </Grid>
      </CardContent>
    </>
  );
}